export const humanName = {
  singular: 'Bônus',
  plural: 'Bônus'
}

export const getApiBasePath = (digitalProductId: string) =>
  `/user/digital_products/${digitalProductId}/bonuses`

export const getRedemptionPath = (digitalProductId: string) =>
  `/user/digital_products/${digitalProductId}/bonus_redemptions`
